import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
            <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
                <div className="container mx-auto px-4">
                    <div className="flex justify-between items-center py-4">
                        <Link to="/" className="text-2xl font-bold text-bilih-blue">Bilih|ብልህ</Link>
                        <div className="hidden md:flex space-x-6">
                            <NavLink to="/">Home</NavLink>
                            <NavLink to="/about">About</NavLink>
                            <NavLink to="/services">Services</NavLink>
                            <NavLink to="/portfolio">Portfolio</NavLink>
                            <NavLink to="/testimonials">Testimonials</NavLink>
                            <NavLink to="/contact">Contact</NavLink>
                        </div>
                        <button
                            className="md:hidden focus:outline-none"
                            onClick={toggleMenu}
                            aria-label="Toggle menu"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Mobile menu */}
            <div className={`md:hidden fixed inset-0 z-40 bg-white transform ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out`}>
                <div className="flex justify-end p-4">
                    <button
                        className="focus:outline-none"
                        onClick={toggleMenu}
                        aria-label="Close menu"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className="flex flex-col items-center space-y-4 mt-8">
                    <NavLink to="/" onClick={toggleMenu}>Home</NavLink>
                    <NavLink to="/about" onClick={toggleMenu}>About</NavLink>
                    <NavLink to="/services" onClick={toggleMenu}>Services</NavLink>
                    <NavLink to="/portfolio" onClick={toggleMenu}>Portfolio</NavLink>
                    <NavLink to="/testimonials" onClick={toggleMenu}>Testimonials</NavLink>
                    <NavLink to="/contact" onClick={toggleMenu}>Contact</NavLink>
                </div>
            </div>
        </>
    );
}

function NavLink({ to, children, onClick }) {
    return (
        <Link
            to={to}
            className="text-gray-800 hover:text-bilih-blue transition-colors duration-300"
            onClick={onClick}
        >
            {children}
        </Link>
    );
}

export default Navbar;